// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Fo0I","row":"styles_row__2mOUq"};